import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import { Pathway_GraphView } from '../../Pathway_GraphView/Pathway_GraphView.js';
import { Panel_HcsVariables } from '../../Component_ResolutionFunctionEditor/panels/hcs-variables/Panel_HcsVariables.js';
export class Presenter_GraphViewWrapper extends ComponentSync {
    __showResolutionFunctionEditorPanel(options) {
        if (options.resolutionFunctions)
            return this.setState({ panelOptions: { resolutionFunctions: options.resolutionFunctions } });
        if (options.validationItems)
            return this.setState({ panelOptions: { validationItems: options.validationItems } });
        if (options.prettyPrint)
            return this.setState({ panelOptions: { prettyPrint: options.prettyPrint } });
        if (options.editDescription)
            return this.setState({ panelOptions: { editDescription: options.editDescription } });
        this.setState({ panelOptions: undefined });
    }
    deriveStateFromProps(nextProps, state) {
        state.editablePathwayState = nextProps.editablePathwayState;
        state.pathwayId = nextProps.pathwayId;
        state.editablePathwayTransition = nextProps.editablePathwayTransition;
        return state;
    }
    renderGraphView = () => {
        if (!this.props.pathwayId)
            return _jsx(_Fragment, {});
        return _jsx(Pathway_GraphView, { pathwayId: this.props.pathwayId, editablePathwayState: this.props.editablePathwayState, editablePathwayTransition: this.props.editablePathwayTransition });
    };
    renderHcsVariablesPanel = () => {
        if (!this.state.panelOptions?.resolutionFunctions)
            return '';
        return _jsx(Panel_HcsVariables, { hidePanel: () => this.setState({ panelOptions: undefined }), resolutionFunctionItems: this.state.panelOptions.resolutionFunctions });
    };
    render() {
        return _jsxs(_Fragment, { children: [this.renderGraphView(), this.renderHcsVariablesPanel()] });
    }
}
//# sourceMappingURL=Presenter_GraphViewWrapper.js.map